/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/operators/in.json`.

import type { DefinitionDocs } from '../../definition_types';

const docs: DefinitionDocs = {
  description: 'The `IN` operator allows testing whether a field or expression equals an element in a list of literals, fields or expressions.',
  examples: [
    'ROW a = 1, b = 4, c = 3\n| WHERE c-a IN (3, b / 2, a)',
  ],
  params: {
    field: 'An expression.',
    inlist: 'A list of items.',
  },
};

export default docs;
